import { render, staticRenderFns } from "./CartWidget.vue?vue&type=template&id=b9f36e6a&lang=pug"
import script from "./CartWidget.vue?vue&type=script&lang=js"
export * from "./CartWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports